module.exports = __webpack_public_path__ + "assets/66d114bb3b7e2d29fa65e5d6fd0e13fc.mp3";